export default __webpack_public_path__ + "static/media/Branding.f5b0406d.svg";